$(document).ready(function(){

  $('#show_first_img').click(function() {
      $('.tile-media_img_1').css('display', 'block');
      $('.tile-media_img_2').css('display', 'none');
  });

  $('#show_second_img').click(function() {
      $('.tile-media_img_1').css('display', 'none');
      $('.tile-media_img_2').css('display', 'block');
  });
  
  $('.drawer_cart_icon').on('click',function(){
    $('mobile-navigation').attr('open',false)
  })

  $('.drawer_search_icon').on('click',function(){
    $('predictive-search-drawer .new_menu_back').addClass('active')
    $('mobile-navigation').attr('open',false)
    $('predictive-search-drawer').attr('open',true)
  })

  $('predictive-search-drawer .new_menu_back').on('click',function(){
    
    $('mobile-navigation').attr('open',true)
    $('predictive-search-drawer').attr('open',false)
    $('predictive-search-drawer .new_menu_back').removeClass('active')
  })

  $('.search_drawer_search_icon,.search_drawer_cart_icon').on('click',function(){
    $('predictive-search-drawer').attr('open',false)
  })

  $('.drawer__close-button,store-header .header__icon-wrapper[href="/search"]').on('click',function(){
    $('predictive-search-drawer .new_menu_back').removeClass('active')
  })


  // $('button[aria-controls="mobile-menu-drawer"]').on('click',function(){
  //   if( $('#mobile-menu-drawer').attr('open') == undefined ){
  //     $('mobile-navigation').attr('open',true)
  //   }
  // })



  // collection page js
 $('body').on('change','#image_toggle',function(){
        let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
        let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
        console.log("click test");
        if (this.checked) {
            // Show second image
            // $('#show_first_img').removeClass('active');
            // $('#show_second_img').addClass('active');
            $primaryImage.attr('style', 'visibility:hidden;opacity:0;');
            $secondaryImage.attr('style', 'visibility:visible;opacity:1;display:block');
        } else {
            // Show first image
            // $('#show_second_img').removeClass('active');
            // $('#show_first_img').addClass('active');
            $primaryImage.attr('style', 'visibility:visible; opacity:1;');
            $secondaryImage.attr('style', 'visibility:hidden;opacity:0;display:none');
        }
    });

  
 // collection img click change second image
  $('body').on('click','#show_first_img_col',function(){
    $(this).addClass('active') ;
    $("#show_second_img_col").removeClass("active");
    let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
    let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
    $primaryImage.attr('style', 'visibility:visible; opacity:1;');
    $secondaryImage.attr('style', 'visibility:hidden;opacity:0;display:none');
  })

  $('body').on('click','#show_second_img_col',function(){
    $(this).addClass('active') ;
    $("#show_first_img_col").removeClass("active");
    let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
    let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
    
    if ($secondaryImage.length > 0) { 
        $primaryImage.attr('style', 'visibility:hidden;opacity:0;');
        $secondaryImage.attr('style', 'visibility:visible;opacity:1;display:block');
    }
    
  })


  
  
  $('body').on('click','.js-load-more', function(){
   let $this =$(this),
   totalPages = parseInt($('[data-all-pages]').val()),
   currentPage = parseInt($('[data-this-page]').val()),
   datacollurl = $('[data-coll-url]').val();
    
   $this.attr('disabled', true);
   $this.find('[load-more-text]').addClass('hide');
   $this.find('[loader]').removeClass('hide');

    
   let nextUrl = $('[data-next-link]').val();
   let current_page_new = currentPage + 1;
   let next_coll = currentPage + 2;
    
   $.ajax({
     url: nextUrl,
     type: 'GET',
     dataType: 'html',
     success: function(responseHTML){
       if(datacollurl.includes('?')){
         $('[data-next-link]').val(datacollurl + "&page="+next_coll);
       }else{
         $('[data-next-link]').val(datacollurl + "?page="+next_coll);
       }
       $('[data-this-page]').val(current_page_new);
       $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
     },
     complete: function() {
       if(current_page_new < totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
       
       if(current_page_new >= totalPages) {
           var queryString = nextUrl.split('?')[1];
            var params = new URLSearchParams(queryString);
            params.delete('page');
            var newQueryString = '&' + params.toString();
            var apiTemplate = 'sold-out-filter-api';
             if ($('body').hasClass('collection-2025')) {
                apiTemplate = 'sold-out-filter-api-2025';
             }
             console.log(`${datacollurl}?view=${apiTemplate}${newQueryString}`);
            $.ajax({
               url: `${datacollurl}?view=${apiTemplate}${newQueryString}`,
               type: 'GET',
               dataType: 'html',
               success: function(responseHTML){
                 $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
               }
             })
         $this.find('[load-more-text]').text('All Products loaded').removeClass('hide'); $this.find('[loader]').addClass('hide');
       } 
     }
   })
  }); 

if (window.location.href.includes("/collections/")) {
  if (!$('.js-load-more').length > 0) {
    let datacollurlNew = $('[data-coll-url]').val();
    let currentURL = window.location.href;
     var apiTemplate = 'sold-out-filter-api';
     if ($('body').hasClass('collection-2025')) {
        apiTemplate = 'sold-out-filter-api-2025';
     }
      
      let ajaxURL = `${datacollurlNew}?view=${apiTemplate}`;
      if (currentURL.includes('?')) {
        ajaxURL = `${currentURL}&view=${apiTemplate}`;
      }
    
    $.ajax({
       url: ajaxURL,
       type: 'GET',
       dataType: 'html',
       success: function(responseHTML){
         $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
       }
     })
    
  }
}
  // nav bar open/close on click - Mobile menu
  // $('body').on('click','.mobile-nav__link',function(){
  //   let navItemclicked = $(this).attr('aria-controls');
  //   $('.mobile-nav__link').each(function(){
  //     let navItem = $(this).attr('aria-controls');
  //     if (navItemclicked != navItem) {
  //       $(this).attr('aria-expanded', false);
  //       $(this).siblings('collapsible-content').css("overflow", "hidden");
  //       $(this).siblings('collapsible-content').removeAttr("open");
  //     }
  //   })
  // })



$('body').on('click', '.cart_title_remove_icon', function () {
  const parent = $(this).closest('line-item.line-item');
  const anchor = parent.find('.line-item__remove-button');
  
  if (anchor.length) {
    anchor[0].click(); // Use native DOM click method
  } else {
    console.warn('Anchor tag not found!');
  }
});
  
$('body').on('click', '.line-itemprop_edit .edit_set', function () {
  const parent = $(this).closest('line-item.line-item');
  const anchor = parent.find('.line-item__content-wrapper .line-item__image-wrapper');
  
  if (anchor.length) {
    anchor[0].click(); // Use native DOM click method
  } else {
    console.warn('Anchor tag not found!');
  }
});


  $('body').on('click','men-item .back_menu', function(){
    const mobileNavItem = $(this).closest(".mobile-nav__item");
      if (mobileNavItem) {
        const toggleButton = mobileNavItem.find('button[aria-expanded="true"]');
        if (toggleButton) {
            toggleButton.click();
        }
    }
  })
  
  // new home tab section
  $('.new_tab_single').on('click',function(){
      $('.new_tab_single').removeClass('active')
      $(this).addClass('active')

      $('.new_tabs_content').hide()
      $(`.new_tabs_content[data-id=${$(this).attr('id')}]`).show();
    })

// Define the global removeSet function attached to the window object
window.removeSet = function(event) {
    event.preventDefault();
    const clickedButton = event.currentTarget;

    let setIDParent = clickedButton.getAttribute('data-set-id');

    let lineItemLoader = $(`line-item[data-parent-set="${setIDParent}"]`).find('.line-item__loader');
    lineItemLoader.removeAttr('hidden');
    lineItemLoader.find('.line-item__loader-spinner').removeAttr('hidden');
    let lineItemLoaderSet = $(`line-item[data-set="${setIDParent}"]`).find('.line-item__loader');
    lineItemLoaderSet.removeAttr('hidden');
    lineItemLoaderSet.find('.line-item__loader-spinner').removeAttr('hidden');

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let itemsToRemove = [];

            cart.items.forEach(item => {
                for (let propertyName in item.properties) {
                    if (item.properties.hasOwnProperty(propertyName) && propertyName === '_set_id' && item.properties[propertyName] === setIDParent) {
                        itemsToRemove.push({
                            id: item.key,
                            quantity: 0
                        });
                    }
                }
            });

            if (itemsToRemove.length > 0) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        updates: itemsToRemove.reduce((acc, item) => {
                            acc[item.id] = item.quantity;
                            return acc;
                        }, {})
                    })
                })
                .then(response => response.json())
                .then(() => {
                    document.querySelector(`.line-item__remove-button[data-set-id="${setIDParent}"]`).click();
                })
                .catch(error => console.error('Error:', error));
            } else {
              document.querySelector(`.line-item__remove-button[data-set-id="${setIDParent}"]`).click();
            }
        })
        .catch(error => console.error('Error:', error));
}



    $('body').on('mouseenter', 'color-choose-drawer#color-choose-drawer .product__media-list', function () {
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('li:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', 'color-choose-drawer#color-choose-drawer .product__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('li:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});


$('body').on('mouseenter', 'color-choose-drawer#color-choose-drawer .color__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            const $secondDot = $pageDots.find('.flickity-page-dot:nth-child(2)');
            if ($secondDot.length) {
                $secondDot.trigger('click');
            }
            const $secondDotList = $pageDots.find('li:nth-child(2)');
            if ($secondDotList.length) {
                $secondDotList.trigger('click');
            }
        }
    }
});

$('body').on('mouseleave', 'color-choose-drawer#color-choose-drawer .color__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('.flickity-page-dot:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
            const $firstDotList = $pageDots.find('li:nth-child(1)');
            if ($firstDotList.length) {
                $firstDotList.trigger('click');
            }
        }
    }
});


  $('body').on('mouseenter', '.flickity__media-list', function () {
  if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
    }
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('.flickity-page-dot:nth-child(2)');
                const $secondDotNew = $pageDots.find('.dot:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
                if ($secondDotNew.length) {
                    $secondDotNew.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', '.flickity__media-list', function () {
  if ($(this).closest('.popup_color_slider_inner').length > 0) {
  console.log($(this).closest('.popup_color_slider_inner'));
        return;
    }
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('.flickity-page-dot:nth-child(1)');
            const $firstDotNew = $pageDots.find('.dot:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
            if ($firstDotNew.length) {
                $firstDotNew.trigger('click');
            }
        }
    }
});
  
  // collection 2025
    $('body').on('mouseenter', '.product__media-list', function () {
      if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
    }
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('li:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', '.product__media-list', function () {
  if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
    }
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('li:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});


// collection 2025
//     $('body').on('mouseenter', '.main_media_silder .product__media-list', function () {
//         const $parent = $(this);
//         if ($parent.length) {
//             const $pageDots = $parent.find('.flickity-page-dots');
//             if ($pageDots.length) {
//                 const $secondDot = $pageDots.find('li:nth-child(2)');
//                 if ($secondDot.length) {
//                     $secondDot.trigger('click');
//                 }
//             }
//         }
//     });

// $('body').on('mouseleave', '.main_media_silder .product__media-list', function () {
//     const $parent = $(this);
//     if ($parent.length) {
//         const $pageDots = $parent.find('.flickity-page-dots');
//         if ($pageDots.length) {
//             // Check hover state using DOM API
//             if ($pageDots[0] && $pageDots[0].matches(':hover')) {
//                 return;
//             }

//             const $firstDot = $pageDots.find('li:nth-child(1)');
//             if ($firstDot.length) {
//                 $firstDot.trigger('click');
//             }
//         }
//     }
// });


$('body').on('click', '.filter_farbe_image .farbe_image', function(){
  const dataName = $(this).attr('data-name');
  const dataVal = $(this).attr('data-value');
  if ($(this).hasClass('active_color')) {
    $(this).removeClass('active_color');
  } else {
    $(this).addClass('active_color');
  }
  $('form#facet-filters-form').find(`input[name="${dataName}"]`).each(function(){
    if ($(this).val() == dataVal) {
      $(this).click();
    }
  })
})

$('body').on('click', '.other_filters .facetfilter_btn', function(){
  const dataControl = $(this).attr('data-aria-controls');
  $('button.product-facet__meta_filter').click();
  $(`.product-facet__filter-item .collapsible-toggle[aria-expanded="true"]`).each(function(){
    $(this).attr('aria-expanded', 'false');
  });
  $(`.product-facet__filter-item .collapsible-toggle[aria-controls="${dataControl}"]`).click();
}) 

  // smart calculator popup
    $('body').on('click', '.smart_calculator_pdp', function(){
        $(".popup_investment_section").addClass("active");
        $('html').addClass('lock-all');
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('doonails:calculator_clicked', {
            product_handle: window.location.pathname.split('/products/')[1] || null
          });
        }
    });
    $(".investment_calculator_section .close--icon-popup, .investment_calculator_section .drawer__overlay, .mobile_close_btn").click(function () {
        $(".popup_investment_section").removeClass("active");
        $('html').removeClass('lock-all');
    });
// smart calculator popup end

// NailFit popup
    $('body').on('click', '.fitnails_pdp ', function(){
        $(".popup_fitnails_section").addClass("active");
        $('html').addClass('lock-all');
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('doonails:shape_finder_clicked', {
            product_handle: window.location.pathname.split('/products/')[1] || null
          });
        }
    });
    $('body').on('click', '.fit_nails_section .fitnails_popup_close, .fit_nails_section .drawer__overlay', function(){
        $(".popup_fitnails_section").removeClass("active");
        $('html').removeClass('lock-all');
    });
// NailFit popup end


// shape guide
    $('body').on('click', '.size_shape_guide_text', function(){
        $(".popup_shapeguide_section").addClass("active");
    });
    $(".close--icon-popup, .shapeguide_heading, .drawer__overlay").click(function () {
        $(".popup_shapeguide_section").removeClass("active");
    });
// shape guide end

// size guide 
$('body').on('click', '.custom_accordion_btn_v2[data-block-title="shapes-lengths"]', function(){
        setTimeout(() => {
          if ($(this).attr('aria-expanded') == 'true') {
            $(".popup_sizeguide_v1_section").addClass("active");
          }
        }, 200);
    });

    $('body').on('click', ".pick_design_sizeguide_v1", function () {
        $(".popup_sizeguide_v1_section").addClass("active");
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('doonails:drawer_length_style_clicked', {
            product_handle: window.location.pathname.split('/products/')[1] || null
          });
        }
    });

    $('body').on('click', ".close-icon-popup, .choose_style_btn, .drawer__overlay", function () {
        $('.custom_accordion_btn[data-block-title="shapes-lengths"]').attr('aria-expanded', 'false');
        $(".popup_sizeguide_v1_section").removeClass("active");
        $(".popup_sizeguide_section").removeClass("active");
    });

    $('body').on('click', '.pick_design_sizeguide', function(){
        $(".popup_sizeguide_section").addClass("active");
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('doonails:drawer_length_style_clicked', {
            product_handle: window.location.pathname.split('/products/')[1] || null
          });
        }
    });

    // $('body').on('click', '.custom_accordion_btn[data-block-title="shapes-lengths"]][aria-expanded="false"]', function(){
    //     setTimeout(() => {
    //         $(".popup_sizeguide_section").addClass("active");
    //         $(".popup_sizeguide_v1_section").addClass("active");
    //     }, 200);
    // });

    $('body').on('click', '.custom_accordion_btn[data-block-title="shapes-lengths"]', function(){
        setTimeout(() => {
          if ($(this).attr('aria-expanded') == 'true') {
            $(".popup_sizeguide_section").addClass("active");
            $(".popup_sizeguide_v1_section").addClass("active");
          }
        }, 200);
    }); 

  // Size guide tab
    $('body').on('click', '.shape_category', function(){
        var name = $(this).attr("data-name");
        $(".shape_category, .point_shapelenght_inner").removeClass("active");
        var matchingElement = $(".point_shapelenght_inner[data-content='" + name + "']");
        if(matchingElement.length) {
            $(this).addClass("active");
            matchingElement.addClass("active");
        }
    });


  // product image gallery
  if ($(window).width() > 900) {
    $(document).on('click', '.product__media-image-wrapper', function(){
      if ($(this).hasClass('zoom')) {
        $('.product__media-image-wrapper').removeClass('zoom');
      } else {
        $('.product__media-image-wrapper').removeClass('zoom');
        $(this).addClass('zoom');
      }
    })
  } else {
    let zoomBusy = false;
    $(document).on('click', '.product__media-image-wrapper img', function () {
      if (zoomBusy) return;
      const productMedia = $(this).closest('product-media.product__media');
      if (!productMedia.length) return;
      const productZoom = productMedia.find('.product__zoom-button[aria-expanded="false"]');
      if (productZoom.length) {
        zoomBusy = true;
        productZoom[0].click();
        setTimeout(() => { zoomBusy = false; }, 0);
      }
    });
  }

$(document).on('click', '.pswp__button[data-action="pswp-close"]', function(){
  setTimeout(() => {
    $(this).closest('.pswp').removeClass(
      'pswp--open pswp--animate_opacity pswp--touch pswp--css_animation pswp--svg pswp--visible pswp--animated-in'
    );
    $('product-image-zoom').removeAttr('open style').attr('aria-hidden', 'true');
  }, 500);
});


  // $(document).on('click', '.pswp__button--close', function(){
  //   $('product-image-zoom.pswp').removeClass('pswp--open pswp--animate_opacity pswp--notouch pswp--css_animation pswp--svg pswp--visible pswp--animated-in').removeAttr('open style').attr('aria-hidden', 'true');
  // })

  // $(window).resize(function() {
  //   if ($(window).width() > 900) {
  //     $('.product__media-image-wrapper').on('click', function(){
  //       if ($(this).hasClass('zoom')) {
  //         $('.product__media-image-wrapper').removeClass('zoom');
  //       } else {
  //         $('.product__media-image-wrapper').removeClass('zoom');
  //         $(this).addClass('zoom');
  //       }
  //     })
  //   } else {
  //     $('.product__media-image-wrapper').on('click', function(){
  //       const productMedia = $(this).closest('product-media.product__media');
  //       if (productMedia && productMedia.length > 0) {
  //         const productZoom = productMedia.find('.product__zoom-button[aria-expanded="false"]');
  //         if (productZoom && productZoom.length > 0) {
  //           productZoom.click();
  //         }
  //       }
  //     })
  //   }
  // })

  $(document).on('click', '.block-swatch__item', function(){
    setTimeout(() => {
      if ($(window).width() > 900) {
        var carouselHeight = $('flickity-carousel.product__media-list.zoom_effect').height();
        // $('flickity-controls .product__thumbnail-list').height(carouselHeight-80);
      } else {
        // $('flickity-controls .product__thumbnail-list').css('height', '100%');
    }
    }, 500);
  })


 
// color chooser zoom popup
$('body').on('click', '.color_zoom_popup', function(){
    const colorHandle = $(this).attr("data-handle");
    const colorTemp = $(this).attr("data-template");
    const designName = $(this).attr("data-name");
    $(".popup_color_slider_section .color_slider_content_inner").html('<span class="loader-button__loader"> <div class="spinner"> <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"> <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle> </svg> </div> </span>');
    $(".popup_color_slider_section").addClass("active");

    let ajaxURL = `/products/${colorHandle}?section_id=popup-inner-images`;
    if (colorTemp) {
      ajaxURL = `/products/${colorHandle}?view=${colorTemp}&section_id=popup-inner-images`;
    };

    fetch(ajaxURL).then( res => res.text() ).then( data => {
      const html = document.createElement("div");
      html.innerHTML = data;
      const newbox = html.querySelector(".popup_color_slider_section .color_slider_content_inner").innerHTML;
      document.querySelector(".popup_color_slider_section .color_slider_content_inner").innerHTML = newbox;
      $(".popup_color_slider_section").addClass("active");
    }) 

    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish('doonails:drawer_design_preview_clicked', {
        design_name: designName,
        product_handle: window.location.pathname.split('/products/')[1] || null
      });
    }

});  


// quick view custom code-start
$('body').on('click', '[is="quick-button"]', function(e){
  e.preventDefault();
  openQuickModal();
  const quickBtn = $(this);
  const dataControl = $(this).attr('aria-controls');
  const quick_view_model = $('#quick_view_model');
  if (!quick_view_model) return;

  $.ajax({
        url: `/products/${dataControl}?view=quick-view`,
        type: "GET",
        dataType: 'html',
        success: function(responseHTML) {
          const rerenderHtml = $(responseHTML).find('product-quick').html();
          quick_view_model.find("product-quick").attr('data-handle', dataControl);
          quick_view_model.find("product-quick").html(rerenderHtml);
          console.log($(this));
          
          if (quickBtn.hasClass('pdp_upsell_product')) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_pdp_cross_selling_product]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
        },
        error: function(xhr, status, error) {
          console.error("Error:", error);
        },
    });
}) 

$('body').on('change', '#quick_view_model form.shopify-product-form [name="id"]', function(){
  const variantID = $(this).val();
  const quick_view_model = $('#quick_view_model');
  const productQuick = $(this).closest("product-quick");
  const dataHandle = productQuick.attr('data-handle');
  const upsell_product = productQuick.find('[name="properties[_pdp_cross_selling_product]"]');
  let upsell_product_found = false;
  if (upsell_product && upsell_product.length && upsell_product.val() == "true") {
    upsell_product_found = true;
  }
  $.ajax({
      url: `/products/${dataHandle}?variant=${variantID}&view=quick-view`,
      type: "GET",
      dataType: 'html',
      success: function(responseHTML) {
          const rerenderHtml = $(responseHTML).find('product-quick').html();
          quick_view_model.find("product-quick").attr('data-handle', dataHandle);
          quick_view_model.find("product-quick").html(rerenderHtml);
          if (upsell_product_found) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_pdp_cross_selling_product]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
          openQuickModal();
      },
      error: function(xhr, status, error) {
          console.error("Error:", error);
      },
  });
}) 

$('body').on('click', '.quick_view_model_close, .quick_view_model_overlay, .mobile_bar_close', function(){
  closeQuickModal();
}) 

$('body').on('click', 'button#AddToCart[data-product-add-to-cart-button]', function(){
  setTimeout(() => {
    closeQuickModal();
  }, 500);
}) 

function openQuickModal() {
  $('#quick_view_model').addClass("is-open");
  document.body.style.overflow = "hidden";
}

function closeQuickModal() {
  $('#quick_view_model').removeClass("is-open");
  document.body.style.overflow = "";
}

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && $('#quick_view_model').hasClass("is-open")) {
    closeQuickModal();
  }
});

// quick view custom code-end


$('.newsletter-custom .footer__item-content button[type="submit"]').on('click', function(e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'UtD6eB']);
}) 

  


window.addEventListener('scroll', () => {
  const btn = document.querySelector('.js-load-more');
  if (!btn || btn.disabled) return;

  const rect = btn.getBoundingClientRect();
  const inView = rect.top < window.innerHeight && rect.bottom >= 0;

  if (inView) {
    btn.click();
  }
});


$(function () {

function updateScrollButtons($parent) {
  const $scroller = $parent.find('.choose_free_gift_flex_product_list');
  const el = $scroller.get(0);
  if (!el) return;

  const scrollWidth = el.scrollWidth;
  const clientWidth = el.clientWidth;
  const scrollLeft  = el.scrollLeft;

  if (scrollWidth > clientWidth) {
    $parent.find('.choose_free_gift_arrows_left')
      .toggleClass('disable', scrollLeft <= 0);

    $parent.find('.choose_free_gift_arrows_right')
      .toggleClass('disable', scrollLeft + clientWidth >= scrollWidth);
  } else {
    $parent.find('.choose_free_gift_arrows_left, .choose_free_gift_arrows_right')
      .addClass('disable');
  }
}

$('body').on('click', '.choose_free_gift_arrows_left:not(.disable)', function () {
  const $parent = $(this).closest('.choose_free_gift_flex');
  const $scroller = $parent.find('.choose_free_gift_flex_product_list');
  const el = $scroller.get(0);
  if (!el) return;
  console.log(el);
  el.scrollBy({ left: -150, behavior: 'smooth' });
  setTimeout(() => updateScrollButtons($parent), 300);
});

$('body').on('click', '.choose_free_gift_arrows_right:not(.disable)', function () {
  const $parent = $(this).closest('.choose_free_gift_flex');
  const $scroller = $parent.find('.choose_free_gift_flex_product_list');
  const el = $scroller.get(0);
  if (!el) return;
  console.log(el);

  el.scrollBy({ left: 150, behavior: 'smooth' });
  setTimeout(() => updateScrollButtons($parent), 300);
});


$('body').on('click', '.choose_free_gift_flex_product_add', async function (e) {
  e.preventDefault();
  e.stopPropagation();

  const giftId = $(this).attr('data-variant');
  try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftId,
            quantity: 1,
            properties: {
              _isGift: true,
              _customer_selected_freegift: true,
              _freeAt: 8500
            }
          })
        }).then(r => r.json());
        await updateCartFreeGiftNew();
      } catch (err) {
        console.error('Error processing free gifts:', err);
      }

});

async function updateCartFreeGiftNew() {
  const miniCartHtml = await fetch('/?section_id=mini-cart').then(r => r.text());
  const tmp = document.createElement('div');
  tmp.innerHTML = miniCartHtml;
  document.querySelector('#mini-cart').innerHTML = tmp.querySelector('#mini-cart').innerHTML;
  const cartContent = await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(r => r.json());

    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: {
        cart: cartContent
      }
    }));
  
}
});

let varidSub = 0;
$('body').on('change', '.subscription_widget_02 input[name="subscription_widget_02"]', function(){
  
    const parentEle = $(this).closest('.subscription_widget_02_wrapper');
    const sellingPlanId = $(this).val();
    const comparePrice = $(this).attr('data-compare-price');
    const salePrice = $(this).attr('data-price');
    const varTitle = $(this).attr('data-variant-title');
    const varID = parseInt($(this).attr('data-variant-id'));
    varidSub = parseInt($(this).attr('data-variant-id'));

    $('.product-form__buy-buttons input[name="id"]').val(varID);

    const optionTitle = $(`variant-picker.product-form__variants label.block-swatch__item[data-value="${varTitle}"]`);
    const optionTitleChecked = $(`variant-picker.product-form__variants input.block-swatch__radio:checked`).attr('data-value');
    if (optionTitleChecked != varTitle) {
        optionTitle.click();
    }

    if (sellingPlanId == 'one_time') {
        // $('.subscription_body').slideUp();
        $('.subscription_widget_02_wrapper').removeClass('active_sub');
        $('#AddToCart[data-product-add-to-cart-button] .loader-button__text').html(`Add to Cart | <span class="atc_price_btn">${salePrice}</span>`);
        $('#AddToCartSub[data-product-add-to-cart-button] .loader-button__text').html(`Add to Cart | <span class="atc_price_btn">${salePrice}</span>`);
        if ($('form.shopify-product-form input[name="selling_plan"]').length > 0) {
            $('form.shopify-product-form input[name="selling_plan"]').val('');
        }
        // $('.product-tile-item.product_2in1-file-buffer').hide();
        // $('.product-tile-item.product_remover-oil').hide();
        // $('.buy_buttons_quantity_wrapper').show();
        // $('.subscription_widget_02 .sw_cc_buy_buttons').hide();
    } else {
        // $('.subscription_body').slideUp();
        $('.subscription_widget_02_wrapper').removeClass('active_sub');
        parentEle.addClass('active_sub');
        // parentEle.find('.subscription_body').slideDown();
        $('#AddToCart[data-product-add-to-cart-button] .loader-button__text').html(`Start ${varTitle} Mani-Box | <span class="atc_price_btn">${salePrice}</span> <span class="atc_copmare_btn">${comparePrice}</span>`);
        $('#AddToCartSub[data-product-add-to-cart-button] .loader-button__text').html(`Start ${varTitle} Mani-Box | <span class="atc_price_btn">${salePrice}</span> <span class="atc_copmare_btn">${comparePrice}</span>`);
        if ($('form.shopify-product-form input[name="selling_plan"]').length > 0) {
            $('form.shopify-product-form input[name="selling_plan"]').val(sellingPlanId);
        } else {
            $('form.shopify-product-form').append(`<input type="hidden" name="selling_plan" value="${sellingPlanId}">`);
        }
        // $('.product-tile-item.product_2in1-file-buffer').show();
        // $('.product-tile-item.product_remover-oil').show();
        // $('.buy_buttons_quantity_wrapper').hide();
        // $('.subscription_widget_02 .sw_cc_buy_buttons').show();
    }  
});

document.addEventListener('variant:changed', function(event) {
  setTimeout(() => {
    $(`.subscription_widget_02 input[data-variant-id="${varidSub}"]`).prop('checked', true);
    $(`.subscription_widget_02 input[data-variant-id="${varidSub}"]`).trigger('change');
    if ($('.subscription_widget_02 input[data-variant-id]').first()) {
      $('#AddToCart[data-product-add-to-cart-button]').addClass('inventory-product');
    }
  }, 50);
});

if (varidSub == 0) {
  $('.subscription_widget_02 input[data-variant-id]').first().prop('checked', true);
}
if ($('.subscription_widget_02 input[data-variant-id]').first()) {
  $('#AddToCart[data-product-add-to-cart-button]').addClass('inventory-product');
}
const currentVarId = $('form.shopify-product-form input[name="id"]').val();
if (currentVarId) {
  $(`.subscription_widget_04 input[data-variant-id="${currentVarId}"]`).prop('checked', true);
  $(`.subscription_widget_04 input[data-variant-id="${currentVarId}"]`).trigger('change');
}



  $('body').on('click', '.additional_product_tab_item', function(){
    const $parent = $(this).closest('.additional_product_row');
    const tabKey = $(this).attr('data-tab');
    $parent.find('.additional_product_content').removeClass('active_tab');
    $parent.find('.additional_product_tab_item').removeClass('active_tab');
    $(this).addClass('active_tab');
    $parent.find(`.additional_product_content[data-tab="${tabKey}"]`).addClass('active_tab');
  }) 

  $('body').on('click', '.subscription_free_product_head', function(){
    const $parent = $(this).closest('.subscription_free_product');
    if ($parent.hasClass('active')) {
      $parent.find('.subscription_free_product_body').slideUp();
      $parent.removeClass('active');
    } else {
      $parent.find('.subscription_free_product_body').slideDown();
      $parent.addClass('active');
    }
  })


  
$('body').on('click', '#AddToCartSubPro', async function(){
    var $addToCartButton = $(this);
    const $that = this;
    
    const $form = $addToCartButton.closest('form');
    if (!$form.length) return;

    const productVariantId = $form.find('[name="id"]').val();
    if (!productVariantId) return;
    $addToCartButton.prop("disabled", true).attr("aria-busy", "true").addClass("is-disabled");
    const formData = new FormData($form[0]);

      try {
          const cart = await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(res => res.json());
          const existingItem = cart.items.find(
            item => item.variant_id == productVariantId
          );

          if (!existingItem) {
              const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: formData,
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest"
                }
              });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }
          }

            fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
                    const html = document.createElement("div");
                    html.innerHTML = data;
                    const newbox = html.querySelector("#mini-cart").innerHTML;
                    document.querySelector('#mini-cart').innerHTML = newbox;
                })

                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                    const cartContent = await response2.json();
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                        bubbles: true,
                        detail: {
                            cart: cartContent
                        }
                    }));

                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                        }
                    }));

                });
              const cartUpdateEvent = new Event('cartUpdate');
              window.dispatchEvent(cartUpdateEvent);
              $addToCartButton.prop("disabled", false).removeAttr("aria-busy").removeClass("is-disabled");

              $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
          
        } catch (error) {
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
            $addToCartButton.prop("disabled", false).removeAttr("aria-busy").removeClass("is-disabled");
        }

  })


  $('body').on('change', '.one_time_and_subscription_buttons input[name="subscription_type"]', function(){
    if ($(this).hasClass('one_time_btn')) {
      $('.subscription_widget_02_container').removeClass('active_tab');
      $('.subscription_widget_02_container.onetime_variants').addClass('active_tab');
      $('.subscription_widget_02_container.onetime_variants label').first().click();
    } else if ($(this).hasClass('subscription_btn')) {
      $('.subscription_widget_02_container').removeClass('active_tab');
      $('.subscription_widget_02_container.sub_variants').addClass('active_tab');
      $('.subscription_widget_02_container.sub_variants label').first().click();
    }
  })


     // valentines-sale discount code
// $('body').on('click', '.copy_discount_code', function(){
//       var copyText = $(this).attr("data-copy");
//       if (!copyText || !navigator.clipboard) return;
//       const $btn = $(this);
//       navigator.clipboard.writeText(copyText).then(async function () {
//         $btn.addClass("show-tooltip");

//       try {
//             if (copyText) {
//                 localStorage.setItem('storedDiscount', copyText);
//                 const response =  await fetch(`/discount/${copyText}`);
//                 const responseText = await response.text();
//                 var parser = new DOMParser();
//                 var htmlDoc = parser.parseFromString(responseText, "text/html");
//                 // console.log("Discount HTML document:", htmlDoc);
//                 if (response.status == 200) {
//                   document.body.classList.add('love_discount_code_applied');
//                   var discount = readCookie('discount_code');
//                   if (discount && discount == copyText) {
//                     document.getElementById("discount-banner-text").innerHTML = "<span>Super! Your discount code <b>" + discount + "</b> has been added to the shopping cart.</span>";
//                       console.log("banner_storage");
//                       $("#discount-banner").css("display", "flex");
//                       sessionStorage.setItem("banner-session", 1);
//                   } else {
//                     console.log("code_not_defined")
//                     $("#discount-banner").css("display", "none");
//                   }

//                   fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
//                       const html = document.createElement("div");
//                       html.innerHTML = data;
//                       const newbox = html.querySelector("#mini-cart").innerHTML;
//                       document.querySelector('#mini-cart').innerHTML = newbox;
//                   })

//                 }
//             }

//         } catch(error) {
//             console.error(`Error: ${error.message}`)
//         }

//         setTimeout(function () {
//           $btn.removeClass("show-tooltip");
//         }, 1500);
//       });
//   });

// function readCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == ' ') 
//       c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) 
//       return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// };


$('.scroller_button_menu').on('click', function(){
  const targetElement = $(this).attr('data-target');
  $('button.fl_humb.header__icon-wrapper[aria-controls="mobile-menu-drawer"][aria-expanded="true"]').click();
  let elementDiv = $('#cart_scroll');
  if (targetElement == "whats-included") {
    elementDiv = $('.custom_accordion_btn[data-block-title="included-in-the-set"]');
    const jsElement = elementDiv.get(0);
    jsElement.click();
  } else if (targetElement == "how-apply") {
    elementDiv = $('.custom_accordion_btn[data-block-title="application"]');
    const jsElement = elementDiv.get(0);
    jsElement.click();
  } else if (targetElement == "owner-video") {
    elementDiv = $('#reeview-app-widget_668bd97bd567f1050e162df1');
  } else if (targetElement == "perfect-nails") {
    elementDiv = $('.pdp-salon-quality');
  } else if (targetElement == "reusable") {
    elementDiv = $('#shopify-section-template--26277241749884__image_with_text_NWA4gp');
  } else if (targetElement == "perfect-fit") {
    elementDiv = $('#shopify-section-template--26277241749884__image_with_text_TdYBqg');
  } else if (targetElement == "about") {
    elementDiv = $('#shopify-section-template--26277241749884__bottom_image_with_text_3XVPUe');
  } else if (targetElement == "faq") {
    elementDiv = $('#shopify-section-template--26277241749884__faq_accordion_with_image_LVUaq4');
  }
  $('html, body').animate({
        scrollTop: elementDiv.offset().top - 150
    }, 100);
})

$('.review_block_drawer').on('click', function(){
  $('button.fl_humb.header__icon-wrapper[aria-controls="mobile-menu-drawer"][aria-expanded="true"]').click();
  let elementDiv = $('#shopify-section-template--26277241749884__17356359937c95579b');
  $('html, body').animate({
        scrollTop: elementDiv.offset().top - 150
    }, 100);
})


// klaviyo collection
$('body').on('click', '.view_pdp_btn.klaviyo-bis-card-trigger', function(){
  const link = $(this).attr("data-product-url");
  sessionStorage.setItem('klaviyoBackToStock', '1');
  window.location.href = link;
});

if ($('body').is('[data-template]')) {
    const templateName = $('body').attr('data-template');
    if (templateName == "product" && sessionStorage.getItem("klaviyoBackToStock") !== null) {
      sessionStorage.removeItem('klaviyoBackToStock');
      if ($('button#AddToCart').is('[disabled]')) {
          var klaviyoBtnInterval = setInterval(function () {
          var $btn = $('form.shopify-product-form #klaviyo-bis-button-container button');

          if ($btn.length) {
            clearInterval(klaviyoBtnInterval);
            $btn.trigger('click');
          }
        }, 500);

        setTimeout(function () {
          clearInterval(klaviyoBtnInterval);
        }, 30000);
      }
    }
}

// klaviyo collection end here


$(document).on('click', '.header__linklist-link', function () {
  const labelText = $(this).attr('data-nav-label');
  if (labelText && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
    Shopify.analytics.publish('doonails:nav_clicked', {
      nav_label: labelText,
      product_handle: window.location.pathname.split('/products/')[1] || null
    });
  }
})
  
  
}); // ready function end




// mobile device base link
 (function () {
  if (!document || !document.querySelectorAll) return;
  const buttons = document.querySelectorAll(".app_widget_btn_link");
  if (!buttons.length) return;
  buttons.forEach(function (btn) {
    if (!btn || !btn.addEventListener) return;

    btn.addEventListener("click", function (e) {
      try {
        e.preventDefault();
        const copyText = btn.getAttribute("data-copy") || "";
        const androidLink = btn.getAttribute("data-android") || "";
        const iosLink = btn.getAttribute("data-ios") || "";
        const webLink = btn.getAttribute("data-web") || "";
        const userAgent =
          (typeof navigator !== "undefined" &&
            (navigator.userAgent || navigator.vendor)) ||
          "";

        const redirect = () => {
          if (/android/i.test(userAgent) && androidLink) {
            window.location.href = androidLink;
          } else if (
            /iPad|iPhone|iPod/.test(userAgent) &&
            !window.MSStream &&
            iosLink
          ) {
            window.location.href = iosLink;
          } else if (webLink) {
            window.location.href = webLink;
          }
        };

        if (
          copyText &&
          navigator &&
          navigator.clipboard &&
          navigator.clipboard.writeText
        ) {
          navigator.clipboard
            .writeText(copyText)
            .then(() => {
              const originalText = btn.innerText || "";
              btn.innerText = "Code Copied!";
              setTimeout(() => {
                btn.innerText = originalText;
                redirect();
              }, 1200);
            })
            .catch(() => {
              redirect();
            });
        } else {
          redirect();
        }
      } catch (err) {
        console.error("Button handler error:", err);
      }
    });
  });
})();

// sale page load more
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".image_with_product_section");
  if (!sections.length) return;
  sections.forEach((section) => {
    const productsWrapper = section.querySelector(".load_product");
    const items = section.querySelectorAll(".load_product .new_product_item");
    const loadMoreBtn = section.querySelector(".loadMoreProduct");
    if (!productsWrapper || !items.length || !loadMoreBtn) {
      if (loadMoreBtn) loadMoreBtn.style.display = "none";
      return;
    }
    const isMobile = window.innerWidth <= 768;
    const initialCount = isMobile ? 6 : 8;
    const increment = 4;
    let visibleCount = initialCount;
    items.forEach((item, index) => {
      item.style.display = index < initialCount ? "flex" : "none";
    });

    loadMoreBtn.style.display = items.length > initialCount ? "block" : "none";
    loadMoreBtn.addEventListener("click", function () {
      visibleCount += increment;
      items.forEach((item, index) => {
        if (index < visibleCount) {
          item.style.display = "flex";
        }
      });

      if (visibleCount >= items.length) {
        loadMoreBtn.style.display = "none";
      }
    });
  });
});


// slider for sale week section:image with product
document.addEventListener("DOMContentLoaded", () => {
  const iwpDesktopMedia = window.matchMedia("(min-width: 769px)");

  function iwpEqualHeights() {
    const iwpItems = document.querySelectorAll(".iwp-product-slider .product-item-meta");
    if (!iwpItems.length) return;

    // Reset first
    iwpItems.forEach((iwpEl) => {
      iwpEl.style.minHeight = "0px";
      iwpEl.style.height = "auto";
    });

    // Wait for browser layout update
    requestAnimationFrame(() => {
      let iwpMaxHeight = 0;

      iwpItems.forEach((iwpEl) => {
        const iwpHeight = iwpEl.getBoundingClientRect().height;
        if (iwpHeight > iwpMaxHeight) {
          iwpMaxHeight = iwpHeight;
        }
      });

      iwpItems.forEach((iwpEl) => {
        iwpEl.style.minHeight = Math.ceil(iwpMaxHeight) + "px";
      });
    });
  }

  function iwpRunEqualHeightAfterLayout() {
    setTimeout(iwpEqualHeights, 100);
    setTimeout(iwpEqualHeights, 300);
    setTimeout(iwpEqualHeights, 700);
  }

  if (!iwpDesktopMedia.matches) return;

  document.querySelectorAll(".iwp-product-slider .product__media-list").forEach((iwpEl) => {
    const iwpMediaFlkty = new Flickity(iwpEl, {
      pageDots: true,
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      prevNextButtons: false,
      draggable: false,
      fade: true,
    });

    iwpMediaFlkty.on("ready", iwpRunEqualHeightAfterLayout);
    iwpMediaFlkty.on("settle", iwpRunEqualHeightAfterLayout);
  });

  setTimeout(() => {
    document.querySelectorAll(".iwp-product-slider").forEach((iwpEl) => {
      const iwpOldFlkty = Flickity.data(iwpEl);
      if (iwpOldFlkty) {
        iwpOldFlkty.destroy();
      }

      const iwpMainFlkty = new Flickity(iwpEl, {
        pageDots: false,
        fade: false,
        cellAlign: "left",
        contain: true,
        rightToLeft: false,
        wrapAround: false,
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15,
        },
      });

      iwpMainFlkty.on("ready", iwpRunEqualHeightAfterLayout);
      iwpMainFlkty.on("settle", iwpRunEqualHeightAfterLayout);
    });

    iwpRunEqualHeightAfterLayout();
  }, 200);

  window.addEventListener("load", iwpRunEqualHeightAfterLayout);

  let iwpResizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(iwpResizeTimer);

    iwpResizeTimer = setTimeout(() => {
      if (iwpDesktopMedia.matches) {
        iwpRunEqualHeightAfterLayout();
      } else {
        document.querySelectorAll(".iwp-product-slider .product-item-meta").forEach((iwpEl) => {
          iwpEl.style.minHeight = "";
          iwpEl.style.height = "";
        });
      }
    }, 200);
  });
});



  // set minHeight with js IWP section
// function iwpSetEqualHeights() {
//   const iwpItems = document.querySelectorAll('.iwp-product-slider .product-item-meta');
//   if (!iwpItems.length) return;

//   iwpItems.forEach(iwpItem => iwpItem.style.minHeight = '');

//   let iwpMaxHeight = 0;

//   iwpItems.forEach(iwpItem => {
//     const iwpItemHeight = iwpItem.offsetHeight;
//     if (iwpItemHeight > iwpMaxHeight) {
//       iwpMaxHeight = iwpItemHeight;
//     }
//   });

//   iwpItems.forEach(iwpItem => {
//     iwpItem.style.minHeight = iwpMaxHeight + 'px';
//   });
// }

// window.addEventListener('load', iwpSetEqualHeights);
// window.addEventListener('resize', iwpSetEqualHeights);

// document.querySelectorAll('.tpc-tab').forEach(iwpTab => {
//   iwpTab.addEventListener('click', () => {
//     setTimeout(iwpSetEqualHeights, 80);
//   });
// });

// product description warning button
document.querySelectorAll('.custom_accordion_btn[data-block-title="inhaltsstoffe"]').forEach(btn => {
  const wrapper = btn.closest('.product-tabs__tab-item-wrapper');
  if (!wrapper) return;

  const warningMessage = wrapper.querySelector('.warning_message');
  const productMeta = wrapper.querySelector('.product_content_meta');
  const warningButton = wrapper.querySelector('.warning_button');

  btn.addEventListener('click', () => {
    // if (warningMessage) warningMessage.style.display = '';
    // if (productMeta) productMeta.style.display = 'none';

    setTimeout(() => {
      if (warningMessage) warningMessage.style.display = '';
      if (productMeta) productMeta.style.display = 'none';
    }, 500);
  });

  if (warningButton) {
    warningButton.addEventListener('click', () => {
      if (warningMessage) warningMessage.style.display = 'none';
      if (productMeta) productMeta.style.display = '';
    });
  }

  if (warningMessage && productMeta) {
    productMeta.style.display = 'none';
  }
});